import "../assets/index-f8d6daf3.css";
import c from "./NcActions.mjs";
import u from "./NcActionButton.mjs";
import p from "./NcLoadingIcon.mjs";
import d from "./NcVNodes.mjs";
import f from "./NcButton.mjs";
import { t as s } from "../chunks/l10n-ef44019c.mjs";
import { C as _ } from "../chunks/ChevronDown-a72d365d.mjs";
import { n as l } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
import { useIsMobile as m } from "../Composables/useIsMobile.mjs";
import { N as h } from "../chunks/NcInputConfirmCancel-a612e6a3.mjs";
import { G as g } from "../chunks/GenRandomId-cb9ccebe.mjs";
const v = {
  name: "ChevronUpIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var y = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon chevron-up-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(a) {
    return e.$emit("click", a);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, C = [], b = /* @__PURE__ */ l(
  v,
  y,
  C,
  !1,
  null,
  null,
  null,
  null
);
const k = b.exports;
const $ = {
  name: "NcAppNavigationIconCollapsible",
  components: {
    NcButton: f,
    ChevronDown: _,
    ChevronUp: k
  },
  props: {
    open: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["click"],
  computed: {
    labelButton() {
      return this.open ? s("Collapse menu") : s("Open menu");
    }
  },
  methods: {
    onClick(n) {
      this.$emit("click", n);
    }
  }
};
var N = function() {
  var e = this, t = e._self._c;
  return t("NcButton", { staticClass: "icon-collapse", class: { "icon-collapse--open": e.open }, attrs: { type: "tertiary", "aria-label": e.labelButton }, on: { click: e.onClick }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [e.open ? t("ChevronUp", { attrs: { size: 20 } }) : t("ChevronDown", { attrs: { size: 20 } })];
  }, proxy: !0 }]) });
}, B = [], L = /* @__PURE__ */ l(
  $,
  N,
  B,
  !1,
  null,
  "07582bf6",
  null,
  null
);
const A = L.exports, S = {
  name: "PencilIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var x = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon pencil-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(a) {
    return e.$emit("click", a);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, I = [], z = /* @__PURE__ */ l(
  S,
  x,
  I,
  !1,
  null,
  null,
  null,
  null
);
const w = z.exports, V = {
  name: "UndoIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var U = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon undo-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(a) {
    return e.$emit("click", a);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M12.5,8C9.85,8 7.45,9 5.6,10.6L2,7V16H11L7.38,12.38C8.77,11.22 10.54,10.5 12.5,10.5C16.04,10.5 19.05,12.81 20.1,16L22.47,15.22C21.08,11.03 17.15,8 12.5,8Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, D = [], E = /* @__PURE__ */ l(
  V,
  U,
  D,
  !1,
  null,
  null,
  null,
  null
);
const M = E.exports;
const O = {
  name: "NcAppNavigationItem",
  components: {
    NcActions: c,
    NcActionButton: u,
    NcAppNavigationIconCollapsible: A,
    NcInputConfirmCancel: h,
    NcLoadingIcon: p,
    NcVNodes: d,
    Pencil: w,
    Undo: M
  },
  props: {
    /**
     * If you are not using vue-router you can use the property to set this item as the active navigation entry.
     * When using vue-router and the `to` property this is set automatically.
     */
    active: {
      type: Boolean,
      default: !1
    },
    /**
     * The main text content of the entry.
     */
    name: {
      type: String,
      required: !0
    },
    /**
     * The title attribute of the element.
     */
    title: {
      type: String,
      default: null
    },
    /**
     * id attribute of the list item element
     */
    id: {
      type: String,
      default: () => "app-navigation-item-" + g(),
      validator: (n) => n.trim() !== ""
    },
    /**
     * Refers to the icon on the left, this prop accepts a class
     * like 'icon-category-enabled'.
     */
    icon: {
      type: String,
      default: ""
    },
    /**
     * Displays a loading animated icon on the left of the element
     * instead of the icon.
     */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
     * Passing in a route will make the root element of this
     * component a `<router-link />` that points to that route.
     * By leaving this blank, the root element will be a `<li>`.
     */
    to: {
      type: [String, Object],
      default: null
    },
    /**
     * A direct link. This will be used as the `href` attribute.
     * This will ignore any `to` prop being defined.
     */
    href: {
      type: String,
      default: null
    },
    /**
     * Pass in `true` if you want the matching behaviour to
     * be non-inclusive: https://router.vuejs.org/api/#exact
     */
    exact: {
      type: Boolean,
      default: !1
    },
    /**
     * Gives the possibility to collapse the children elements into the
     * parent element (true) or expands the children elements (false).
     */
    allowCollapse: {
      type: Boolean,
      default: !1
    },
    /**
     * Makes the name of the item editable by providing an `ActionButton`
     * component that toggles a form
     */
    editable: {
      type: Boolean,
      default: !1
    },
    /**
     * Only for 'editable' items, sets label for the edit action button.
     */
    editLabel: {
      type: String,
      default: ""
    },
    /**
     * Only for items in 'editable' mode, sets the placeholder text for the editing form.
     */
    editPlaceholder: {
      type: String,
      default: ""
    },
    /**
     * Pins the item to the bottom left area, above the settings. Do not
     * place 'non-pinned' `AppnavigationItem` components below `pinned`
     * ones.
     */
    pinned: {
      type: Boolean,
      default: !1
    },
    /**
     * Puts the item in the 'undo' state.
     */
    undo: {
      type: Boolean,
      default: !1
    },
    /**
     * The navigation collapsible state (synced)
     */
    open: {
      type: Boolean,
      default: !1
    },
    /**
     * The actions menu open state (synced)
     */
    menuOpen: {
      type: Boolean,
      default: !1
    },
    /**
     * Force the actions to display in a three dot menu
     */
    forceMenu: {
      type: Boolean,
      default: !1
    },
    /**
     * The action's menu default icon
     */
    menuIcon: {
      type: String,
      default: void 0
    },
    /**
     * The action's menu direction
     */
    menuPlacement: {
      type: String,
      default: "bottom"
    },
    /**
     * Entry aria details
     */
    ariaDescription: {
      type: String,
      default: null
    },
    /**
     * To be used only when the elements in the actions menu are very important
     */
    forceDisplayActions: {
      type: Boolean,
      default: !1
    },
    /**
     * Number of action items outside the menu
     */
    inlineActions: {
      type: Number,
      default: 0
    }
  },
  emits: [
    "update:menuOpen",
    "update:open",
    "update:name",
    "click",
    "undo"
  ],
  setup() {
    return {
      isMobile: m()
    };
  },
  data() {
    return {
      editingValue: "",
      opened: this.open,
      // Collapsible state
      editingActive: !1,
      hasChildren: !1,
      /**
       * Tracks the open state of the actions menu
       */
      menuOpenLocalValue: !1,
      focused: !1
    };
  },
  computed: {
    isRouterLink() {
      return this.to && !this.href;
    },
    collapsible() {
      return this.allowCollapse && !!this.$slots.default;
    },
    // Checks if the component is already a children of another
    // instance of AppNavigationItem
    canHaveChildren() {
      return this.$parent.$options._componentTag !== "AppNavigationItem";
    },
    hasUtils() {
      return !!(this.$slots.actions || this.$slots.counter || this.editable || this.undo);
    },
    editButtonAriaLabel() {
      return this.editLabel ? this.editLabel : s("Edit item");
    },
    undoButtonAriaLabel() {
      return s("Undo changes");
    },
    actionsBoundariesElement() {
      return document.querySelector("#content-vue") || void 0;
    }
  },
  watch: {
    open(n) {
      this.opened = n;
    }
  },
  created() {
    this.updateSlotInfo();
  },
  beforeUpdate() {
    this.updateSlotInfo();
  },
  methods: {
    // sync opened menu state with prop
    onMenuToggle(n) {
      this.$emit("update:menuOpen", n), this.menuOpenLocalValue = n;
    },
    // toggle the collapsible state
    toggleCollapse() {
      this.opened = !this.opened, this.$emit("update:open", this.opened);
    },
    /**
     * Handle link click
     *
     * @param {PointerEvent} event - Native click event
     * @param {Function} [navigate] - VueRouter link's navigate if any
     * @param {string} [routerLinkHref] - VueRouter link's href
     */
    onClick(n, e, t) {
      this.$emit("click", n), !(n.metaKey || n.altKey || n.ctrlKey || n.shiftKey) && t && (e == null || e(n), n.preventDefault());
    },
    // Edition methods
    handleEdit() {
      this.editingValue = this.name, this.editingActive = !0, this.onMenuToggle(!1), this.$nextTick(() => {
        this.$refs.editingInput.focusInput();
      });
    },
    cancelEditing() {
      this.editingActive = !1;
    },
    handleEditingDone() {
      this.$emit("update:name", this.editingValue), this.editingValue = "", this.editingActive = !1;
    },
    // Undo methods
    handleUndo() {
      this.$emit("undo");
    },
    updateSlotInfo() {
      this.hasChildren = !!this.$slots.default;
    },
    /**
     * Show actions upon focus
     */
    handleFocus() {
      this.focused = !0;
    },
    handleBlur() {
      this.focused = !1;
    },
    /**
     * This method checks if the root element of the component is focused and
     * if that's the case it focuses the actions button if available
     *
     * @param {Event} e the keydown event
     */
    handleTab(n) {
      this.$refs.actions && (this.focused ? (n.preventDefault(), this.$refs.actions.$refs.menuButton.$el.focus(), this.focused = !1) : this.$refs.actions.$refs.menuButton.$el.blur());
    },
    /**
     * Is this an external link
     *
     * @param {string} href The link to check
     * @return {boolean} Whether it is external or not
     */
    isExternal(n) {
      return n && n.match(/[a-z]+:\/\//i);
    }
  }
};
var R = function() {
  var e = this, t = e._self._c;
  return t("li", { staticClass: "app-navigation-entry-wrapper", class: {
    "app-navigation-entry--opened": e.opened,
    "app-navigation-entry--pinned": e.pinned,
    "app-navigation-entry--collapsible": e.collapsible
  }, attrs: { id: e.id } }, [t(e.isRouterLink ? "router-link" : "NcVNodes", { tag: "component", attrs: { custom: !!e.isRouterLink, to: e.to, exact: e.isRouterLink ? e.exact : null }, scopedSlots: e._u([{ key: "default", fn: function({ href: a, navigate: r, isActive: o }) {
    return [t("div", { staticClass: "app-navigation-entry", class: {
      "app-navigation-entry--editing": e.editingActive,
      "app-navigation-entry--deleted": e.undo,
      active: o && e.to || e.active
    } }, [e.undo ? e._e() : t("a", { staticClass: "app-navigation-entry-link", attrs: { "aria-current": e.active || o && e.to ? "page" : void 0, "aria-description": e.ariaDescription, "aria-expanded": e.hasChildren ? e.opened.toString() : void 0, href: e.href || a || "#", target: e.isExternal(e.href) ? "_blank" : void 0, title: e.title || e.name }, on: { blur: e.handleBlur, click: function(i) {
      return e.onClick(i, r, a);
    }, focus: e.handleFocus, keydown: function(i) {
      return !i.type.indexOf("key") && e._k(i.keyCode, "tab", 9, i.key, "Tab") || i.ctrlKey || i.shiftKey || i.altKey || i.metaKey ? null : e.handleTab.apply(null, arguments);
    } } }, [t("div", { staticClass: "app-navigation-entry-icon", class: { [e.icon]: e.icon } }, [e.loading ? t("NcLoadingIcon") : e._t("icon")], 2), e.editingActive ? e._e() : t("span", { staticClass: "app-navigation-entry__name" }, [e._v(" " + e._s(e.name) + " ")]), e.editingActive ? t("div", { staticClass: "editingContainer" }, [t("NcInputConfirmCancel", { ref: "editingInput", attrs: { placeholder: e.editPlaceholder !== "" ? e.editPlaceholder : e.name, primary: o && e.to }, on: { cancel: e.cancelEditing, confirm: e.handleEditingDone }, model: { value: e.editingValue, callback: function(i) {
      e.editingValue = i;
    }, expression: "editingValue" } })], 1) : e._e()]), e.undo ? t("div", { staticClass: "app-navigation-entry__deleted" }, [t("div", { staticClass: "app-navigation-entry__deleted-description" }, [e._v(" " + e._s(e.name) + " ")])]) : e._e(), e.hasUtils && !e.editingActive ? t("div", { staticClass: "app-navigation-entry__utils", class: { "app-navigation-entry__utils--display-actions": e.forceDisplayActions || e.menuOpenLocalValue || e.menuOpen } }, [e.$slots.counter ? t("div", { staticClass: "app-navigation-entry__counter-wrapper" }, [e._t("counter")], 2) : e._e(), e.$slots.actions || e.editable && !e.editingActive || e.undo ? t("NcActions", { ref: "actions", staticClass: "app-navigation-entry__actions", attrs: { inline: e.inlineActions, container: "#app-navigation-vue", "boundaries-element": e.actionsBoundariesElement, placement: e.menuPlacement, open: e.menuOpen, type: o && e.to ? "primary" : null, "force-menu": e.forceMenu, "default-icon": e.menuIcon }, on: { "update:open": e.onMenuToggle }, scopedSlots: e._u([{ key: "icon", fn: function() {
      return [e._t("menu-icon")];
    }, proxy: !0 }], null, !0) }, [e.editable && !e.editingActive ? t("NcActionButton", { attrs: { "aria-label": e.editButtonAriaLabel }, on: { click: e.handleEdit }, scopedSlots: e._u([{ key: "icon", fn: function() {
      return [t("Pencil", { attrs: { size: 20 } })];
    }, proxy: !0 }], null, !0) }, [e._v(" " + e._s(e.editLabel) + " ")]) : e._e(), e.undo ? t("NcActionButton", { attrs: { "aria-label": e.undoButtonAriaLabel }, on: { click: e.handleUndo }, scopedSlots: e._u([{ key: "icon", fn: function() {
      return [t("Undo", { attrs: { size: 20 } })];
    }, proxy: !0 }], null, !0) }) : e._e(), e._t("actions")], 2) : e._e()], 1) : e._e(), e.collapsible ? t("NcAppNavigationIconCollapsible", { attrs: { open: e.opened }, on: { click: function(i) {
      return i.preventDefault(), i.stopPropagation(), e.toggleCollapse.apply(null, arguments);
    } } }) : e._e(), e._t("extra")], 2)];
  } }], null, !0) }), e.canHaveChildren && e.hasChildren ? t("ul", { staticClass: "app-navigation-entry__children" }, [e._t("default")], 2) : e._e()], 1);
}, P = [], K = /* @__PURE__ */ l(
  O,
  R,
  P,
  !1,
  null,
  "24094dee",
  null,
  null
);
const ee = K.exports;
export {
  ee as default
};
